import { useState } from "react";
import './ContactForm.css';
import ExitButton from "../common/ExitButton";

// ContactForm component

export default function ContactForm({ closeAllOverlays }) {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);


  // Sending the input data to the API endpoint in the backend
  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("Sende...");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/contact-form/contact-form`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          message: form.message,
        }),
      });

      if (!res.ok) throw new Error(`Fehler: ${res.status}`);
      setStatus("Nachricht erfolgreich gesendet!");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      console.error(err);
      setStatus("Fehler beim Senden: " + err.message);
    }
  }

  return (
    <div className="PopupContent">
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ExitButton onClick={closeAllOverlays} />
      </div>
      <form className="ContactForm" onSubmit={handleSubmit}>
        <h1>Hast du Ideen?</h1>
        <p>Teile deine Vorschläge, Wünsche oder Fragen mit uns. Wir sind gespannt auf deine Nachricht! Bitte gib deine E-Mailadresse an, wenn du eine Antwort von uns erhalten möchtest.</p>
        <input
            type="text"
            placeholder="Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            maxLength="50"
        />
        <input
            type="email"
            placeholder="E-Mail"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            maxLength="75"
        />
        <textarea
            placeholder="Nachricht"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            minLength="50"
            maxLength="2000"
            required
            aria-required
        />
        
        {/* Honeypot field */}
        <input
            type="text"
            name="hp"
            value={form.hp}
            onChange={e => setForm({...form, hp: e.target.value})}
            style={{ display: 'none' }}
        />
        <button className="TextButton" type="submit">Absenden</button>
        {status && <p className="FormStatus">{status}</p>}
      </form>
    </div>
  );
}